module.exports = __webpack_public_path__ + "img/H2.356935bb.png";